module.exports = __webpack_public_path__ + "static/media/_MIC2396.image.3eae03b4.png";